import { render, staticRenderFns } from "./pointViewDrag.vue?vue&type=template&id=21cc5079&scoped=true&"
import script from "./pointViewDrag.vue?vue&type=script&lang=js&"
export * from "./pointViewDrag.vue?vue&type=script&lang=js&"
import style0 from "./pointViewDrag.vue?vue&type=style&index=0&id=21cc5079&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc5079",
  null
  
)

export default component.exports